/** @format */

export const LinkedinLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.7781 2.66669H8.22255C5.15477 2.66669 2.66699 5.15446 2.66699 8.22224V23.7778C2.66699 26.8456 5.15477 29.3334 8.22255 29.3334H23.7781C26.847 29.3334 29.3337 26.8456 29.3337 23.7778V8.22224C29.3337 5.15446 26.847 2.66669 23.7781 2.66669ZM11.5559 23.7778H8.22255V11.5556H11.5559V23.7778ZM9.88921 10.1467C8.81588 10.1467 7.94477 9.26891 7.94477 8.18669C7.94477 7.10446 8.81588 6.22669 9.88921 6.22669C10.9625 6.22669 11.8337 7.10446 11.8337 8.18669C11.8337 9.26891 10.9637 10.1467 9.88921 10.1467ZM24.8892 23.7778H21.5559V17.5511C21.5559 13.8089 17.1114 14.0922 17.1114 17.5511V23.7778H13.7781V11.5556H17.1114V13.5167C18.6625 10.6434 24.8892 10.4311 24.8892 16.2678V23.7778Z"
                fill={color}
            />
        </svg>
    );
};
